import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef } from 'react';
import classNames from 'classnames/bind';
import { useCuttedTextSign } from "../../hooks/useCuttedTextSign";
import styles from './Clamp.css';
var cx = classNames.bind(styles);
export var Clamp = function Clamp(_ref) {
  var children = _ref.children,
      _ref$lineHeight = _ref.lineHeight,
      lineHeight = _ref$lineHeight === void 0 ? 20 : _ref$lineHeight;
  var refContainer = useRef(null);

  var _useCuttedTextSign = useCuttedTextSign(refContainer),
      height = _useCuttedTextSign.height;

  var webkitLineClamp = Math.floor(height / lineHeight);
  return /*#__PURE__*/React.createElement("span", {
    className: cx('root'),
    ref: refContainer,
    style: _objectSpread({}, webkitLineClamp === 0 ? {
      visibility: 'hidden'
    } : {})
  }, /*#__PURE__*/React.createElement("span", {
    className: cx('text'),
    style: {
      height: webkitLineClamp * lineHeight,
      WebkitLineClamp: "".concat(webkitLineClamp)
    }
  }, children));
};